import { Outlet, useLocation } from "react-router-dom";
import Header from "../components/Header/Header";
import Footer from "../components/Footer/Footer";
import SeoHead from "../components/Seo/SeoHead";
import ErrorBoundary from "../components/ui/ErrorBoundary";
import { SeoProvider } from "../seo/SeoContext";
import MobileCtaBar from "../components/MobileCtaBar/MobileCtaBar";
import { useEffect } from "react";
import { captureAttribution } from "../api/waitlist";

export default function Layout() {
    const location = useLocation();

    // Remember UTM tags / a friend's referral code from the first page of the visit.
    useEffect(() => {
        captureAttribution();
    }, [location.search]);

    return (
        <SeoProvider>
            <div className="flex min-h-screen flex-col bg-canvas font-sans text-body">
                <SeoHead />
                <Header />
                <main id="main-content" tabIndex={-1} className="flex-grow overflow-x-clip bg-canvas pt-[72px] outline-none">
                    <ErrorBoundary key={location.pathname}>
                        <Outlet />
                    </ErrorBoundary>
                </main>
                <Footer />
                <MobileCtaBar />
            </div>
        </SeoProvider>
    );
}
